module.exports = __webpack_public_path__ + "img/mind_icon_number_8.6a0b1426.png";